import {defineStore} from 'pinia';
import {ModuleBudgetChapter} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import ColumnCommon from '@/commons/wildcards/constants/ColumnCommon';
import budgetChapterAPI from '@/apis/di/budgetChapterAPI';

const buChapterStore = new BaseDictionaryStore(budgetChapterAPI);

export const useBuChapterStore = defineStore(ModuleBudgetChapter, {
  state: () => ({
    ...buChapterStore.state,
    _config: {
      key: ColumnCommon.budget_chapter_id,
      code: ColumnCommon.budget_chapter_code,
      name: ColumnCommon.budget_chapter_name,
      table: 'di_budget_chapter',
      moduleName: 'Chương',
      defaultSort: ColumnCommon.budget_chapter_code,
      quickFollow: 'active',
    },
    moduleName: 'budgetChapter',
  }),
  actions: {...buChapterStore.action},
  getters: {...buChapterStore.getters},
});
